export default "__VITE_ASSET__BbnNlbF5__"